/**
 * Niveaux de log disponibles
 */
export enum LogLevel {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  DEBUG = 'DEBUG'
}

/**
 * Interface pour un événement de log
 */
interface LogEvent {
  level: LogLevel;
  message: string;
  timestamp: string;
  details?: unknown;
}

/**
 * Classe principale de logging
 */
class Logger {
  private static instance: Logger | null = null;
  private logs: LogEvent[] = [];

  private constructor() {}

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  /**
   * Log un message avec le niveau spécifié
   */
  private log(level: LogLevel, message: string, details?: unknown): void {
    const logEvent: LogEvent = {
      level,
      message,
      timestamp: new Date().toISOString(),
      details
    };

    this.logs.push(logEvent);
    
    // En développement, on affiche aussi dans la console
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${logEvent.level}] ${logEvent.message}`, details || '');
    }
  }

  public info(message: string, details?: unknown): void {
    this.log(LogLevel.INFO, message, details);
  }

  public warn(message: string, details?: unknown): void {
    this.log(LogLevel.WARN, message, details);
  }

  public error(message: string, details?: unknown): void {
    this.log(LogLevel.ERROR, message, details);
  }

  public debug(message: string, details?: unknown): void {
    if (process.env.NODE_ENV === 'development') {
      this.log(LogLevel.DEBUG, message, details);
    }
  }

  /**
   * Récupère les logs pour une période donnée
   */
  public getLogs(startTime?: Date, endTime?: Date): LogEvent[] {
    return this.logs.filter(log => {
      const logTime = new Date(log.timestamp);
      return (!startTime || logTime >= startTime) && (!endTime || logTime <= endTime);
    });
  }
}

// Créer l'instance singleton
const loggerInstance = Logger.getInstance();

// Exporter uniquement l'instance singleton
export default loggerInstance;

